import React from 'react';
import { TypedObject } from '@sanity/types';
import { useQuery } from 'react-query';
import { fetchPoiById } from 'data/fetchers';
import ExpandedPoiCard from 'components/cards/poi/ExpandedPoiCard';

interface PoiBlock extends TypedObject {
    id: string;
    name: string;
    slug: string;
    _type: 'poi';
}

const PoiBlock = ({ value: block }: { value: PoiBlock }) => {
    const { data } = useQuery(['poi', block.id], () => fetchPoiById(block.id));

    const poi = data?.data;

    return <ExpandedPoiCard poi={poi} loading={!poi} />;
};

export default PoiBlock;
